export var FormBuilderInputType;
(function (FormBuilderInputType) {
    FormBuilderInputType["Input"] = "input";
    FormBuilderInputType["Textarea"] = "textarea";
    FormBuilderInputType["Select"] = "select";
    FormBuilderInputType["Switch"] = "switch";
    FormBuilderInputType["Space"] = "space";
    FormBuilderInputType["Password"] = "password";
    FormBuilderInputType["Number"] = "number";
    FormBuilderInputType["SelectIntegration"] = "integration";
    FormBuilderInputType["SelectBase"] = "select-base";
    FormBuilderInputType["SelectTable"] = "select-table";
    FormBuilderInputType["SelectView"] = "select-view";
    FormBuilderInputType["SelectField"] = "select-field";
    FormBuilderInputType["OAuth"] = "oauth";
    FormBuilderInputType["Checkbox"] = "checkbox";
    FormBuilderInputType["WorkflowInput"] = "workflow-input";
    FormBuilderInputType["KeyValue"] = "key-value";
    FormBuilderInputType["EntitySelector"] = "entity-selector";
    FormBuilderInputType["ConditionBuilder"] = "condition-builder";
})(FormBuilderInputType || (FormBuilderInputType = {}));
/**
 * Enum defining all available validator types
 */
export var FormBuilderValidatorType;
(function (FormBuilderValidatorType) {
    FormBuilderValidatorType["Required"] = "required";
    FormBuilderValidatorType["Regex"] = "regex";
    FormBuilderValidatorType["MinValue"] = "minValue";
    FormBuilderValidatorType["MaxValue"] = "maxValue";
    FormBuilderValidatorType["MinLength"] = "minLength";
    FormBuilderValidatorType["MaxLength"] = "maxLength";
    FormBuilderValidatorType["Email"] = "email";
    FormBuilderValidatorType["Url"] = "url";
    FormBuilderValidatorType["Custom"] = "custom";
})(FormBuilderValidatorType || (FormBuilderValidatorType = {}));
/**
 * Default category name for elements without a specified category
 */
export const FORM_BUILDER_NON_CATEGORIZED = 'form-builder-non-categorized';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2Zvcm1CdWlsZGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBTixJQUFZLG9CQW1CWDtBQW5CRCxXQUFZLG9CQUFvQjtJQUM5Qix1Q0FBZSxDQUFBO0lBQ2YsNkNBQXFCLENBQUE7SUFDckIseUNBQWlCLENBQUE7SUFDakIseUNBQWlCLENBQUE7SUFDakIsdUNBQWUsQ0FBQTtJQUNmLDZDQUFxQixDQUFBO0lBQ3JCLHlDQUFpQixDQUFBO0lBQ2pCLHlEQUFpQyxDQUFBO0lBQ2pDLGtEQUEwQixDQUFBO0lBQzFCLG9EQUE0QixDQUFBO0lBQzVCLGtEQUEwQixDQUFBO0lBQzFCLG9EQUE0QixDQUFBO0lBQzVCLHVDQUFlLENBQUE7SUFDZiw2Q0FBcUIsQ0FBQTtJQUNyQix3REFBZ0MsQ0FBQTtJQUNoQyw4Q0FBc0IsQ0FBQTtJQUN0QiwwREFBa0MsQ0FBQTtJQUNsQyw4REFBc0MsQ0FBQTtBQUN4QyxDQUFDLEVBbkJXLG9CQUFvQixLQUFwQixvQkFBb0IsUUFtQi9CO0FBOENEOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksd0JBVVg7QUFWRCxXQUFZLHdCQUF3QjtJQUNsQyxpREFBcUIsQ0FBQTtJQUNyQiwyQ0FBZSxDQUFBO0lBQ2YsaURBQXFCLENBQUE7SUFDckIsaURBQXFCLENBQUE7SUFDckIsbURBQXVCLENBQUE7SUFDdkIsbURBQXVCLENBQUE7SUFDdkIsMkNBQWUsQ0FBQTtJQUNmLHVDQUFXLENBQUE7SUFDWCw2Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBVlcsd0JBQXdCLEtBQXhCLHdCQUF3QixRQVVuQztBQXFrQkQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSw0QkFBNEIsR0FBRyw4QkFBOEIsQ0FBQyJ9